<template>
    <Breadcrumbs main="Maps" title="Vue Leaflet" />
    <div class="container-fluid">
        <div class="row">

            <Card9 colClass="col-xl-6 " cardhaderClass="pb-0 title-header" title="Simple Map">
                <simpleMap />
            </Card9>


            <Card9 colClass="col-xl-6 " cardhaderClass="pb-0 title-header" title="Multi-language support" span="true" :spanClass="desc">
                <multiLanguage />
            </Card9>


            <Card9 colClass="col-xl-12" cardhaderClass="pb-0 title-header" title="Multi-language support" span="true" :spanClass="desc">
                <multiLanguage2 />
            </Card9>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const simpleMap = defineAsyncComponent(() => import("@/components/theme/maps/simpleMap.vue"))
const multiLanguage = defineAsyncComponent(() => import("@/components/theme/maps/multiLanguage.vue"))
const multiLanguage2 = defineAsyncComponent(() => import("@/components/theme/maps/multiLanguage2.vue"))
let desc = "Display a map with labels in a foreign language"
</script>